import React from "react";

const brl = (n) =>
  n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const ResumoSection = ({ conta = "Não encontrada", valor = 0, modo = "saldo", parcelas = 1, calcularParcela = (n) => n }) => {
  // Calcula o resumo com base no modo e parcelas
  const resumo = {
    forma: modo === "saldo" ? "Saldo (à vista)" : "Cartão de crédito",
    condicao:
      modo === "saldo"
        ? "À vista"
        : `${parcelas}x de ${brl(calcularParcela(valor, parcelas))}`,
  };

  return (
    <section className="boleto-section" style={{ marginTop: "1rem" }}>
      <h3 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "0.75rem", color: "#0f172a" }}>
        Resumo
      </h3>

      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          fontSize: "0.875rem",
        }}
      >
        {/* Card Conta */}
        <div
          style={{
            flex: "1 1 calc(50% - 0.5rem)",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            padding: "1rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            border: "1px solid #E2E8F0",
          }}
        >
          <div style={{ color: "#475569" }}>Conta</div>
          <div style={{ fontWeight: 500, color: "#000" }}>{conta}</div>
        </div>

        {/* Card Valor original */}
        <div
          style={{
            flex: "1 1 calc(50% - 0.5rem)",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            padding: "1rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            border: "1px solid #E2E8F0",
          }}
        >
          <div style={{ color: "#475569" }}>Valor original</div>
          <div style={{ fontWeight: 500, color: "#000" }}>{brl(valor)}</div>
        </div>

        {/* Card Forma de pagamento */}
        <div
          style={{
            flex: "1 1 calc(50% - 0.5rem)",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            padding: "1rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            border: "1px solid #E2E8F0",
          }}
        >
          <div style={{ color: "#475569" }}>Forma de pagamento</div>
          <div style={{ fontWeight: 500, color: "#000" }}>{resumo.forma}</div>
        </div>

        {/* Card Condição */}
        <div
          style={{
            flex: "1 1 calc(50% - 0.5rem)",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            padding: "1rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            border: "1px solid #E2E8F0",
          }}
        >
          <div style={{ color: "#475569" }}>Condição</div>
          <div style={{ fontWeight: 500, color: "#000" }}>{resumo.condicao}</div>
        </div>
      </div>
    </section>
  );
};

export default ResumoSection;